// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23F59201%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%0A%3E%3Cpolyline points=%276 9 12 15 18 9%27 /%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoIcon--P0RiR {
  width: 17px;
  height: 17px;
}[dir] .infoIcon--P0RiR {
  margin-top: -4px;
}[dir=ltr] .infoIcon--P0RiR {
  margin-left: 5px;
}[dir=rtl] .infoIcon--P0RiR {
  margin-right: 5px;
}

.trendOptionTooltip--Wn7Zk {
  display: inline-flex;
  align-items: center;
}

[dir] .trendOptionTooltip--Wn7Zk {
  cursor: help;
}

.trendInfoIcon--a2KWR {
  width: 17px;
  height: 17px;
}

.advancedSelectField--CvPde,
.groupHighlightSelectContainer--FJTDO {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

[dir] .advancedSelectField--CvPde, [dir] .groupHighlightSelectContainer--FJTDO {
  margin-top: 20px;
}

@media (min-width: 768px) {
  [dir] .advancedSelectField--CvPde, [dir] .groupHighlightSelectContainer--FJTDO {
    margin-top: 0;
  }
  [dir] .advancedSelectFieldSpaced--Wywcf, [dir] .groupHighlightSelectContainerData--HbBbT {
    margin-top: 20px;
  }
}

.advancedSelect--jLUoo,
.groupHighlightSelect--sIKpM {
  width: 100%;

  overflow: visible;
  font: inherit;
  color: inherit;
  display: flex;
  vertical-align: middle;
  line-height: 40px;
  text-decoration: none;
  transition: 0.1s ease-in-out;
}

[dir] .advancedSelect--jLUoo, [dir] .groupHighlightSelect--sIKpM {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: white;

  margin: 10px 0;
  border: none;
  border-radius: 5px;
  padding: 0 25px;
  transition-property: color, background-color, border-color;
}

.trendOptions--s7M_0 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

[dir] .trendOptions--s7M_0 {
  margin-bottom: 0;
}
.trendOption--oLSp3 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.trendOption--oLSp3 select {
  min-width: 100px;
}

.dropdown--BEr94 {
  min-width: 100px;
  height: 38px;
  color: #343c42;
  font-family: museo-sans, sans-serif;
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  -webkit-appearance: none;
  -moz-appearance: none;
       appearance: none;
}

[dir] .dropdown--BEr94 {
  margin: 0;
  border: 1px solid #c3c3c3;
  border-radius: 8px;
  box-shadow: none;
}

[dir=ltr] .dropdown--BEr94 {
  padding: 0 34px 0 15px;
}

[dir=rtl] .dropdown--BEr94 {
  padding: 0 15px 0 34px;
}

.dropdown--BEr94:focus-visible {
  outline: 2px solid rgba(230, 81, 45, 0.35);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SettingsPanel/subComponents/DataTablePanel/styles.css"],"names":[],"mappings":"AAAA;EAGE,WAAW;EACX,YAAY;AACd,CALA;EAEE,gBAAgB;AAGlB,CALA;EACE,gBAAgB;AAIlB,CALA;EACE,iBAAgB;AAIlB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AAErB;;AAJA;EAGE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAGE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;;AARA;EAEE,gBAAgB;AAMlB;;AAEA;EACE;IAEE,aAAa;EACf;EACA;IAEE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,WAAW;;EAUX,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,4BAA4B;AAC9B;;AApBA;EAGE,yDAAuR;EACvR,uBAAuB;;EAEvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAU5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AAEX;;AANA;EAKE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EAMZ,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,qBAAgB;OAAhB,gBAAgB;AAClB;;AAfA;EAGE,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAElB,gBAAgB;AAQlB;;AAfA;EAME,sBAAsB;AASxB;;AAfA;EAME,sBAAsB;AASxB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB","sourcesContent":[".infoIcon {\n  margin-left: 5px;\n  margin-top: -4px;\n  width: 17px;\n  height: 17px;\n}\n\n.trendOptionTooltip {\n  display: inline-flex;\n  align-items: center;\n  cursor: help;\n}\n\n.trendInfoIcon {\n  width: 17px;\n  height: 17px;\n}\n\n.advancedSelectField,\n.groupHighlightSelectContainer {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n  .advancedSelectField,\n  .groupHighlightSelectContainer {\n    margin-top: 0;\n  }\n  .advancedSelectFieldSpaced,\n  .groupHighlightSelectContainerData {\n    margin-top: 20px;\n  }\n}\n\n.advancedSelect,\n.groupHighlightSelect {\n  width: 100%;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23F59201' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%0A%3E%3Cpolyline points='6 9 12 15 18 9' /%3E%3C/svg%3E\");\n  background-color: white;\n\n  margin: 10px 0;\n  border: none;\n  border-radius: 5px;\n  padding: 0 25px;\n  transition-property: color, background-color, border-color;\n\n  overflow: visible;\n  font: inherit;\n  color: inherit;\n  display: flex;\n  vertical-align: middle;\n  line-height: 40px;\n  text-decoration: none;\n  transition: 0.1s ease-in-out;\n}\n\n.trendOptions {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 0;\n}\n.trendOption {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.trendOption select {\n  min-width: 100px;\n}\n\n.dropdown {\n  min-width: 100px;\n  height: 38px;\n  margin: 0;\n  border: 1px solid #c3c3c3;\n  border-radius: 8px;\n  padding: 0 34px 0 15px;\n  box-shadow: none;\n  color: #343c42;\n  font-family: museo-sans, sans-serif;\n  font-size: 15px;\n  font-weight: 300;\n  line-height: 1;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.dropdown:focus-visible {\n  outline: 2px solid rgba(230, 81, 45, 0.35);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoIcon": `infoIcon--P0RiR`,
	"trendOptionTooltip": `trendOptionTooltip--Wn7Zk`,
	"trendInfoIcon": `trendInfoIcon--a2KWR`,
	"advancedSelectField": `advancedSelectField--CvPde`,
	"groupHighlightSelectContainer": `groupHighlightSelectContainer--FJTDO`,
	"advancedSelectFieldSpaced": `advancedSelectFieldSpaced--Wywcf`,
	"groupHighlightSelectContainerData": `groupHighlightSelectContainerData--HbBbT`,
	"advancedSelect": `advancedSelect--jLUoo`,
	"groupHighlightSelect": `groupHighlightSelect--sIKpM`,
	"trendOptions": `trendOptions--s7M_0`,
	"trendOption": `trendOption--oLSp3`,
	"dropdown": `dropdown--BEr94`
};
export default ___CSS_LOADER_EXPORT___;
